import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Consultation/ScheduleConsultation/ScheduleConsultation.css";
import "../BookYouRide/BookYourRide.css";
import Heading from '../../../utls/Heading';

const BookYourRide = () => {
    return (
        <>
   <div className="container Schedule-Consultation BookYourRide ">
            <div className="row px-lg-3">
                <div className="col-md-7 col-12"> 
                    <Heading className='headings '><span>How </span>To Book Your Ride<span  style={{ fontWeight: 'bold', color: 'black' }}>?</span></Heading>
                    <p className='mt-3'>Now, you do not have to wait for long periods before getting a taxi. You can simply book a ride with us that comes with trained chauffeurs. However, if you tend to get worried about riding with a chauffeur in a strange land or find it difficult to trust someone behind the wheel, we have a solution for that as well: self-driven car rental. To book your ride, all you need is to follow these three simple steps:</p>

                    <div className="d-flex align-items-center mt-lg-5 mt-md-4">
                        <LazyLoadImage
            effect="blur"
 src='https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/bookrideicon-3.png' alt=""  loading="lazy"  className='Book-ride-icon me-3 mb-3'/>
                       <div className="d-flex flex-column">
                       <h5 className='fw-bold'>Contact Us For Help</h5>
                       <p className='grps-p'>Explain your needs, budget, and location to our customer service agent.
                       </p>
                       </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <LazyLoadImage
            effect="blur"
 src='https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/bookrideicon-2.png' alt="" loading="lazy" className='Book-ride-icon me-3 mb-3' />
                        <div className="d-flex flex-column">
                       <h5 className='fw-bold'>Choose A Plan That Best Suits You</h5>
                       <p className='grps-p'>Based on the suggested plans, pick a plan that you think is ideal.
                       </p>
                       </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <LazyLoadImage
            effect="blur"
 src='https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/bookrideicon-1.png' alt=""  loading="lazy" className='Book-ride-icon me-3 mb-3'/>
                        <div className="d-flex flex-column">
                       <h5 className='fw-bold'>Book Your Ride
                       </h5>
                       <p className='grps-p'>Confirm your chauffeur-driven or self-drive car rental. 

                       </p>
                       </div>
                    </div>
                </div>

                <div className="col-md-5 d-md-block d-none">
                    <div className="schedule-boy-img d-flex justify-content-xxl-center justify-content-lg-end car-rental-book-ride-img">
                        <LazyLoadImage
            effect="blur"
 src='https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/car-rental-services-img.png' alt="" loading="lazy"  />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default BookYourRide   